export default __webpack_public_path__ + "static/media/project2.3b91965a.JPG";